export default ({
  init: () => {
    const header = document.querySelector('header.layout')

    /**
     * Language Toggle
     */
    const langToggle = header.querySelector('.language-toggle')
    if (langToggle) {
      langToggle.addEventListener('click', e => {
        e.preventDefault()
        const href = langToggle.getAttribute('href')

        if (href == '#en') {
          document.cookie = "language_override=en;path=/"
        } else {
          document.cookie = "language_override=es;path=/"
        }

        location.reload()
        return false
      })
    }

    /**
     * Mobile Nav Toggle
     */
    const menuToggle = header.querySelector('.mobile-nav-toggle')
    const menu = header.querySelector('nav.primary')
    menuToggle.addEventListener('click', e => {
      e.preventDefault()

      if (menu.classList.contains('open')) {
        document.body.style.overflow = null
        menuToggle.classList.remove('open')
        menu.classList.remove('open')
      } else {
        document.body.style.overflow = 'hidden'
        menuToggle.classList.add('open')
        menu.classList.add('open')
      }

      return false
    })

    /**
     * Mobile Nav Toggle
     */
    const toggleMiniNav = () => {
      if (header.classList.contains('mini') && (scrollY < 300)) {
        header.classList.add('exiting')
        setTimeout(() => {
          header.classList.remove('exiting')
          header.classList.remove('mini')
        }, 75)
      } else if ((! header.classList.contains('mini')) && (scrollY >= 300)) {
        header.classList.add('mini')
      }
    }

    toggleMiniNav()
    window.addEventListener('scroll', toggleMiniNav)
  }
})
